require('./accountChequebookMovementsTableRow.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @components
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const DateHelper = require('utilities/dateHelper');
const { DATE_FORMAT_ES } = require('constants/index');

// @constants
const {
    HYPHEN,
    ACCOUNT_CHEQUE_PAYED,
    ACCOUNT_CHEQUE_CANCELED,
    ACCOUNT_CHEQUE_PENDING,
    ACCOUNT_CHEQUE_IRREGULAR,
    ACCOUNT_CHEQUE_COMPOSED,
    ACCOUNT_CHEQUE_RETURNED,
    ACCOUNT_CHEQUE_DETERIORATED,
    ACCOUNT_CHEQUE_MISSING,
    ACCOUNT_CHEQUE_STOLEN
} = require('constants/index');

class AccountChequebookMovementsTableRow extends React.Component {

    constructor(props){
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getStatusTranslation(status) {
        switch (status) {
            case ACCOUNT_CHEQUE_PAYED:
                return formatText('accountCheques-chequebookPayed');
            case ACCOUNT_CHEQUE_CANCELED:
                return formatText('accountCheques-chequebookCanceled');
            case ACCOUNT_CHEQUE_PENDING:
                return formatText('accountCheques-chequebookPending');
            case ACCOUNT_CHEQUE_IRREGULAR:
                return formatText('accountCheques-chequebookIrregular');
            case ACCOUNT_CHEQUE_COMPOSED:
                return formatText('accountCheques-chequebookComposed');
            case ACCOUNT_CHEQUE_RETURNED:
                return formatText('accountCheques-chequebookReturned');
            case ACCOUNT_CHEQUE_DETERIORATED:
                return formatText('accountCheques-chequebookDeteriorated');
            case ACCOUNT_CHEQUE_MISSING:
                return formatText('accountCheques-chequebookMissing');
            case ACCOUNT_CHEQUE_STOLEN:
                return formatText('accountCheques-chequebookStolen');
            default:
                return status || HYPHEN;
        }
    }

    render() {
        const { immCheque, originalIndex } = this.props;

        const status = immCheque.get('status').toUpperCase();
        const statusText = this.getStatusTranslation(status);
        const date = immCheque.get('date');
        const plainAmountObject = getPlainAmountObject(immCheque.get('balance'));
        let labelDate = HYPHEN;

        if (!!date) {
            labelDate = DateHelper.buildFormattedDate(date, DATE_FORMAT_ES);
        }

        return (
            <OKTableRow id={`chequebook-row-${originalIndex}`}>
                <OKTableCell className="account-chequebook-movements-table-row__cell-id">
                    {immCheque.get('number')}
                </OKTableCell>
                <OKTableCell className="account-chequebook-movements-table-row__cell-status">
                    {statusText}
                </OKTableCell>
                <OKTableCell className="account-chequebook-movements-table-row__cell-date">
                    {labelDate}
                </OKTableCell>
                <OKTableCell className="account-chequebook-movements-table-row__cell-balance">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        className="account-chequebook-movements-table-row__cell-balance-text"
                        language={getLanguage()}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                    />
                </OKTableCell>
            </OKTableRow>
        )
    }
}

AccountChequebookMovementsTableRow.propTypes = {
    immCheque: PropTypes.object,
    originalIndex: PropTypes.number
};

module.exports = AccountChequebookMovementsTableRow;
